// views/auth/register.js  (FR)
export const register_i18n = {
  alts: { banner: "fond d'inscription", brand: "WA Checkin", footerLogo: "WA Checkin" },
  aria: { toggleReferral: "activer ou désactiver le code d'affilié", togglePassword: "afficher ou masquer le mot de passe" },
  texts: {
    inviteTitle: "Félicitations !",
    inviteText: "{name} vous invite sur WACheckin : vous bénéficiez de {percent} % de réduction sur vos {months} premiers mois.",
    inviteApplied: "Appliqué depuis votre lien d'invitation.",
    panelKicker: "WACHECKIN · 2026",
    panelCta: "Découvrir WACheckin",
    langLabel: "Langue",
    panelTitle: "Configurez-le une fois. Le reste se fait tout seul.",
    panelDesc:
      "Le lien du check-in, le message de bienvenue, les clés et la déclaration aux autorités partent sans que vous ayez à y penser.",
    title: "Créez votre compte",
    infoTitle: "Inscrivez-vous en quelques minutes",
    infoDesc:
      "Complétez vos informations et commencez à automatiser le check-in et la communication avec vos voyageurs.",
    referralHint: "Ne l'activez que si on vous en a donné un.",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
  },
  labels: {
    inviteCode: "Code d'invitation",
    name: "Nom",
    email: "E-mail",
    password: "Mot de passe",
    phone: "Téléphone",
    referralCode: "Code d'affilié",
  },
  placeholders: {
    name: "Saisissez votre nom",
    email: "Saisissez votre e-mail",
    password: "Créez un mot de passe",
    referralCode: "Code",
  },
  buttons: { submit: "Créer un compte", submitting: "Création du compte...", signIn: "Se connecter" },
  validation: { phoneRequired: "Saisissez votre numéro, pas seulement l'indicatif.", phoneInvalid: "Ce numéro n'est pas valide. Vérifiez-le.", invalidReferralCode: "Le code d'affiliation n'est pas valide." },
  toast: {
    signupSuccess: "Compte créé avec succès !",
    signupError: "Échec de l'inscription.",
    networkError: "Erreur de connexion. Réessayez.",
    referralCodeError: "Le code d'affiliation n'est pas valide.",
  },
};
